import React, { useState } from "react";
import * as styles from "/src/components/Project/Slideshow.module.css";
import { FaAngleLeft } from "@react-icons/all-files/fa/FaAngleLeft";
import { FaAngleRight } from "@react-icons/all-files/fa/FaAngleRight";
import { graphql, useStaticQuery } from "gatsby";
import { v4 as uuidv4 } from "uuid";
import Dots from "/src/components/Project/Dots";
import SlideshowCard from "/src/components/Project/SlideshowCard";

const Slideshow = () => {
  const [current, setCurrent] = useState(0);
  const data = useStaticQuery(query).allContentfulProject.nodes;
  const individualData = data[current];
  const [fadeMode, setFadeMode] = useState(0);
  //0 is nothing, 1 is fade in, 2 is fade out

  const length = data.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
    setNext(-1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
    setNext(-1);
  };

  if (length <= 0) {
    return null;
  }

  const setNext = async (id) => {
    if (fadeMode === 0) {
      await setFadeMode(1);
      setTimeout(async () => {
        if (id !== -1) {
          await setCurrent(id);
        }
        await setFadeMode(0);
      }, 500);
    }
  };

  return (
    <div className={styles.slideshow}>
      <div className={styles.title}>
        <h1 className={styles.titleHeader}>Our Projects</h1>
      </div>
      {/* <div className={styles.slideshowimage2}> */}
      <div
        className={`${styles.transitionImage} ${
          fadeMode === 0 ? styles.fadeIn : styles.fadeOut
        }`}
      >
        <SlideshowCard data={individualData} />
      </div>
      <div className={styles.slider}>
        <FaAngleLeft className={styles.leftarrow} onClick={prevSlide} />
        {Array(length)
          .fill()
          .map((val, idx) => (
            <Dots
              key={uuidv4()}
              id={idx}
              onPress={() => setNext(idx)}
              active={current === idx}
            />
          ))}
        <FaAngleRight className={styles.rightarrow} onClick={nextSlide} />
      </div>
    </div>
    // </div>
  );
};

//add filter when in contentfulc
export const query = graphql`
  query getData {
    allContentfulProject(filter: { isFeatured: { eq: true } }, limit: 5) {
      nodes {
        category
        createdAt(formatString: "MMMM Do, YYYY")
        title
        isTakingVolunteers
        summary
        description {
          raw
        }
        images {
          description
          gatsbyImageData(layout: CONSTRAINED, placeholder: TRACED_SVG)
        }
      }
    }
  }
`;

export default Slideshow;
